import type { Tables } from "@/integrations/supabase/types";

export type FeatureRolloutMode = "off" | "admins" | "allowlist" | "all";
export type FeatureTargetType = "user" | "workspace";

export type FeatureFlagTarget = {
  id: string;
  target_type: FeatureTargetType;
  target_id: string;
  created_at: string;
};

export type FeatureFlagRecord = {
  id: string;
  key: string;
  name: string;
  description: string | null;
  enabled: boolean;
  rollout_mode: FeatureRolloutMode;
  updated_at: string;
  created_at: string;
  feature_flag_targets?: FeatureFlagTarget[];
};

export type ProfileRecord = Pick<
  Tables<"profiles">,
  "id" | "owner_user_id" | "display_name" | "workspace_label" | "account_tier" | "is_primary"
>;

export type FeatureFlagDraft = { name: string; description: string };
export type TargetInputState = { user: string; workspace: string };
export type FeatureFlagActivityState = {
  create: boolean;
  saveId: string | null;
  toggleId: string | null;
  rolloutId: string | null;
};

export const rolloutDescriptions: Record<FeatureRolloutMode, string> = {
  off: "No one gets access, even if the master switch is on.",
  admins: "Only admins can use this feature while the flag is enabled.",
  allowlist: "Only admins plus selected users and workspaces can use this feature.",
  all: "Every signed-in user can use this feature while the flag is enabled.",
};

export const starterFlags = [
  { key: "composer_beta", name: "Composer beta", description: "Controls access to the Composer beta surface." },
] as const;

export const rolloutOptions: FeatureRolloutMode[] = ["off", "admins", "allowlist", "all"];
